import { CommonAllergy } from '../../../models';
/**
 * Se ANCHE UN SOLO membro della famiglia ha la SOIA tra le allergie,
 * l'opzione Low-FODMAP è disabilitata per TUTTA la famiglia
 */
export var isLowFodmapDisabledBySoy = function (members) {
    return members.some(function (member) {
        var _a;
        return ((_a = member.commonAllergies) !== null && _a !== void 0 ? _a : []).some(function (allergy) { return allergy === CommonAllergy.Soy; });
    });
};
